import DocReady from 'es6-docready';
var PRODUCT_PAGE_CTA = '[data-element="tagCta"]';
DocReady(function () {
  var productPage = document.querySelector('[data-component="productPage"]');
  var addSpinnerOnClick = function addSpinnerOnClick(event) {
    event.target.matches(PRODUCT_PAGE_CTA) && document.body.classList.add('is-loading');
  };
  if (productPage) {
    productPage.addEventListener('click', addSpinnerOnClick);
  }
});